import { abbreviatePersonName } from '@/utils/format';

/** Position-ordered, abbreviated person names: "J. Kowalski, A. Nowak". */
export const personLine = (
  items: { position: number; name?: string | null }[] | undefined
): string =>
  (items ?? [])
    .slice()
    .sort((a, b) => a.position - b.position)
    .map((item) => (item.name ? abbreviatePersonName(item.name) : null))
    .filter(Boolean)
    .join(', ');
